// ============================================================================
// MICROSOFT ENTRA ID AUTHENTICATION CONFIGURATION
// ============================================================================
// 
// SETUP INSTRUCTIONS:
// 1. Go to https://entra.microsoft.com
// 2. Navigate to: Applications → App registrations → New registration
// 3. Configure:
//    - Name: "CONNECT Portal"
//    - Supported account types: "Accounts in this organizational directory only"
//    - Redirect URI: Select "Single-page application (SPA)" and enter:
//      - For local dev: http://localhost:3000
//      - For production: https://connect.outlooktherapeutics.com
// 4. After creation, copy the "Application (client) ID" and "Directory (tenant) ID"
// 5. Update the values below
//
// ============================================================================

export const msalConfig = {
  auth: {
    // Replace with your Application (client) ID from Entra ID
    clientId: "0e91f7b1-503e-4c10-aebe-a7baeec42e17",
    
    // Replace with your Directory (tenant) ID
    // Format: https://login.microsoftonline.com/YOUR_TENANT_ID
    authority: "https://login.microsoftonline.com/ea8f9616-c989-4b89-89a9-0a33ed0e3d32",
    
    // Must match the redirect URI registered in Entra ID
    redirectUri: window.location.origin,
    
    // Where to redirect after logout
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    // Store auth state in sessionStorage (cleared when browser closes)
    // Use "localStorage" if you want users to stay logged in
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

// Scopes required for the application
export const loginRequest = {
  scopes: ["User.Read", "openid", "profile", "email"],
};

// Scopes for Microsoft Graph API (SharePoint access)
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
  scopes: ["User.Read", "Sites.ReadWrite.All"],
};

// ============================================================================
// ROLE MAPPING CONFIGURATION
// ============================================================================
// 
// Option 1: Map by email address (simple)
// Option 2: Map by Entra ID groups (recommended for production)
//
// For Option 2, you'll need to:
// 1. Create groups in Entra ID: "CONNECT-Recruiters", "CONNECT-Approvers", etc.
// 2. Add the "GroupMember.Read.All" scope
// 3. Configure group claims in your app registration
//
// ============================================================================

// Simple role mapping by email (update with your actual users)
export const roleMapping = {
  // CEO
  "cpuetz@outlooktherapeutics.com": "ceo",
  
  // CFO - add your CFO's email
  "cpuetz@outlooktherapeutics.com": "cfo",
  
  // Recruiters - add recruiter emails
  "cpuetz@outlooktherapeutics@outlooktherapeutics.com": "recruiter",
  "cpuetz@outlooktherapeutics@outlooktherapeutics.com": "recruiter",
  
  // Default role for anyone not listed above
  // They can create requisitions but not approve
  defaultRole: "employee",
};

// Department mapping (optional - can be pulled from Entra ID user profile)
export const departmentMapping = {
  "cpuetz@outlooktherapeutics.com": "Executive",
  // Add more as needed, or we'll use the department from Entra ID profile
};
